import { RemoteComponent } from "@/shared/presentation/components/remote-component";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { Center, Spinner } from "@reverb-ui/react";
import React, { useContext } from "react";
var talentFinancial = {
    url: process.env.GTN_WALLET_REMOTE_URL + "/remoteEntry.js",
    scope: "gtnwallet",
    module: "./Financial",
};
export var FinancialContainer = function () {
    var talentWalletId = useContext(AuthContext).talentWalletId;
    if (talentWalletId)
        return (React.createElement(RemoteComponent, { config: talentFinancial, fallback: React.createElement(Center, { h: "100%" },
                React.createElement(Spinner, { color: "blue.500" })) }));
    return (React.createElement(Center, { h: "100%" },
        React.createElement(Spinner, { color: "blue.500" })));
};
